import { Home, BadgePercent, ShoppingBag, User, Search, ChevronDown } from "lucide-react";
import { Input } from "@/components/ui/input";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { imgUrl } from "@/lib/api";
import { cn } from "@/lib/utils";

const ITEMS = [["inicio", "Início", Home], ["promocoes", "Promoções", BadgePercent], ["pedidos", "Pedidos", ShoppingBag]];

export function ShopTopNav({ view, setView, me, onAccount, color }) {
  const item = (active) => cn("flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-bold transition-colors sm:px-5 sm:py-3 sm:text-lg", active ? "bg-white shadow-sm" : "text-white hover:bg-white/15");
  return (
    <div style={{ background: color }} data-testid="shop-top-nav">
      <nav className="mx-auto flex max-w-7xl items-center justify-around gap-1 px-2 py-3 sm:py-4">
        {ITEMS.map(([k, l, Icon]) => (
          <button key={k} onClick={() => setView(k)} className={item(view === k)} style={view === k ? { color } : {}} data-testid={`shop-nav-${k}`}>
            <Icon className="h-5 w-5 sm:h-6 sm:w-6" /><span className="hidden min-[420px]:inline">{l}</span>
          </button>
        ))}
        <button onClick={onAccount} className={item(false)} data-testid="shop-nav-account">
          <User className="h-5 w-5 sm:h-6 sm:w-6" /><span className="hidden min-[420px]:inline">{me ? `Olá, ${me.name.split(" ")[0]}` : "Entrar/Cadastrar"}</span>
        </button>
      </nav>
    </div>
  );
}

export function ShopStickyBar({ st, categories, onCat, q, setQ, view, setView, color }) {
  return (
    <div className="sticky top-0 z-30 border-b border-slate-200 bg-white/95 backdrop-blur" data-testid="shop-sticky-bar">
      <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 py-3">
        {st.logo_url && <img src={imgUrl(st.logo_url)} alt="Logo" className="hidden h-12 w-12 shrink-0 rounded-lg bg-black object-cover sm:block" />}
        <DropdownMenu>
          <DropdownMenuTrigger className="flex h-12 shrink-0 items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 text-sm font-medium text-slate-700 hover:bg-slate-50 sm:px-5" data-testid="shop-categories-btn">
            <span className="hidden sm:inline">Lista de categorias</span><span className="sm:hidden">Categorias</span><ChevronDown className="h-4 w-4" />
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start" className="max-h-[60vh] overflow-y-auto bg-white text-slate-900">
            {categories.map((c) => <DropdownMenuItem key={c.id} onClick={() => onCat(c.id)} data-testid={`shop-cat-${c.id}`}>{c.name}</DropdownMenuItem>)}
          </DropdownMenuContent>
        </DropdownMenu>
        <div className="relative ml-auto w-full max-w-md">
          <Search className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" />
          <Input value={q} onChange={(e) => { setQ(e.target.value); setView("inicio"); }} placeholder="Busque por um produto" className="h-12 bg-white pl-10 text-slate-900" data-testid="shop-search-input" />
        </div>
        <div className="hidden items-center gap-6 pl-4 lg:flex">
          {ITEMS.map(([k, l, Icon]) => (
            <button key={k} onClick={() => setView(k)} className={cn("flex flex-col items-center text-xs font-medium transition-colors", view === k ? "" : "text-slate-600 hover:text-slate-900")} style={view === k ? { color } : {}} data-testid={`shop-bar-${k}`}>
              <Icon className="h-6 w-6" />{l}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
